<div class="d-flex flex-1 flex-column">
  <div class="border-top py-1">
    <p>
      {{ totalLabel || 'Total:' }} <strong>{{ items.length }}</strong>
    </p>
  </div>

  <div class="lui-toggle-list__content row">
    <ng-content></ng-content>
  </div>

  <button
    luiTextButton
    *ngIf="isLimitExceeded"
    class="d-flex align-items-center my-2 mx-auto"
    type="button"
    iconPosition="end"
    (click)="toggleItems(!isOpen)"
  >
    <div *ngIf="!isOpen; else viewLess" i18n>View more</div>
    <ng-template #viewLess i18n>View less</ng-template>
    <mat-icon [svgIcon]="isOpen ? 'chevron_up' : 'chevron_down'"></mat-icon>
  </button>
</div>
